import React from 'react';
import styled from 'styled-components';
import { Text, Input, Card } from 'components';
import { CreateListingCardProps, MoreInfoFields } from '../types';
import { StyledGrid } from './StyledComponents';

type MoreInfoProps = CreateListingCardProps<MoreInfoFields>;

const MoreInfo: React.FC<MoreInfoProps> = ({ more_info, setListing }) => {
  const handleChange = (changes: Partial<MoreInfoProps['more_info']>) => {
    setListing(prev => ({
      ...prev,
      more_info: { ...prev.more_info, ...changes },
    }));
  };
  return (
    <Card type="primary" title="More Info" id="moreInfo">
      <StyledGrid $columns={3}>
        <StyledDimensionsWrapper>
          <StyledDimensionsLabel strong>Total Area</StyledDimensionsLabel>
          <Input
            placeholder="Width"
            value={more_info.total_area?.width}
            onChange={({ target: { value } }) => {
              handleChange({
                total_area: { ...more_info.total_area, width: value },
              });
            }}
            data-cy="listing-commercial-total-area-width"
          />
          <Text textAlign="center">X</Text>
          <Input
            placeholder="Length"
            value={more_info.total_area?.length}
            onChange={({ target: { value } }) => {
              handleChange({
                total_area: { ...more_info.total_area, length: value },
              });
            }}
            data-cy="listing-commercial-total-area-length"
          />
        </StyledDimensionsWrapper>
        <StyledDimensionsWrapper>
          <StyledDimensionsLabel strong>
            Office / Apt Area
          </StyledDimensionsLabel>
          <Input
            placeholder="Width"
            value={more_info.office?.width}
            onChange={({ target: { value } }) => {
              handleChange({
                office: { ...more_info.office, width: value },
              });
            }}
            data-cy="listing-commercial-office-width"
          />
          <Text textAlign="center">X</Text>
          <Input
            placeholder="Length"
            value={more_info.office?.length}
            onChange={({ target: { value } }) => {
              handleChange({
                office: { ...more_info.office, length: value },
              });
            }}
            data-cy="listing-commercial-office-length"
          />
        </StyledDimensionsWrapper>
        <StyledDimensionsWrapper>
          <StyledDimensionsLabel strong>Industrial Area</StyledDimensionsLabel>
          <Input
            placeholder="Width"
            value={more_info.industrial?.width}
            onChange={({ target: { value } }) => {
              handleChange({
                industrial: { ...more_info.industrial, width: value },
              });
            }}
            data-cy="listing-commercial-industrial-width"
          />
          <Text textAlign="center">X</Text>
          <Input
            placeholder="Length"
            value={more_info.industrial?.length}
            onChange={({ target: { value } }) => {
              handleChange({
                industrial: { ...more_info.industrial, length: value },
              });
            }}
            data-cy="listing-commercial-industrial-length"
          />
        </StyledDimensionsWrapper>
        <StyledDimensionsWrapper>
          <StyledDimensionsLabel strong>Retail Area</StyledDimensionsLabel>
          <Input
            placeholder="Width"
            value={more_info.retail?.width}
            onChange={({ target: { value } }) => {
              handleChange({
                retail: { ...more_info.retail, width: value },
              });
            }}
            data-cy="listing-commercial-retail-width"
          />
          <Text textAlign="center">X</Text>
          <Input
            placeholder="Length"
            value={more_info.retail?.length}
            onChange={({ target: { value } }) => {
              handleChange({
                retail: { ...more_info.retail, length: value },
              });
            }}
            data-cy="listing-commercial-retail-length"
          />
        </StyledDimensionsWrapper>
        <Input
          label="Freestanding"
          value={more_info.freestanding}
          onChange={({ target: { value } }) =>
            handleChange({
              freestanding: value as 'Y' | 'N',
            })
          }
          data-cy="listing-commercial-freestanding"
        />
        <Input
          label="Zoning"
          value={more_info.zoning}
          onChange={({ target: { value } }) =>
            handleChange({
              zoning: value,
            })
          }
          data-cy="listing-commercial-zoning"
        />
      </StyledGrid>
    </Card>
  );
};

const StyledDimensionsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 25px 1fr;
  align-items: flex-end;
`;

const StyledDimensionsLabel = styled(Text)`
  grid-column-end: span 3;
`;

export default React.memo(MoreInfo);
